<template>
    <span>
        <span
            v-if="plan.is_max_5g_connection_type"
            class="border-dotted"
            style="border-bottom: 1px dotted currentColor; cursor: pointer;"
            v-b-tooltip.hover
            :title="noticeText"
        >
            Max 5G speed
        </span>
        <template v-else>
            {{ speedText }}
        </template>
    </span>
</template>

<script>
export default {
    props: {
        plan: Object,
        callback: Function
    },
    computed: {
        speedText() {
            if (typeof this.callback === 'function') {
                return this.callback(this.plan);
            }

            const rowConfig = this.$parent.rowConfig;
            if (rowConfig) {
                if (typeof rowConfig.formattedValueExpression === 'function') {
                    return rowConfig.formattedValueExpression(this.plan);
                }
                if (typeof rowConfig.rawValueExpression === 'function') {
                    return 'Up to ' + rowConfig.rawValueExpression(this.plan) + ' Mbps';
                }
            }

            return '';
        },
        noticeText() {
            return this.$store.state.common.max_5g_notice || '';
        }
    }
}
</script>